// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"dbcbbb27","96":"c4de5471","129":"4f5ddaf9","233":"140f99ab","453":"ce451b92","469":"42221a59","731":"89e003d1"}[chunkId] + ".chunk.js";
};